"use client";

import { usePathname, useSearchParams, useRouter } from "next/navigation";
import { Stepper } from "@/components/ui/stepper";

export const CHECKOUT_STEPS = [
  { number: 1, label: "Add To Cart" },
  { number: 2, label: "Address" },
  { number: 3, label: "Payment" },
];

export default function CheckoutHeader() {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const router = useRouter();
  const step = searchParams.get("step");

  // Determine current step based on pathname and query params
  let currentStep = 1;
  let breadcrumbs: { label: string; href?: string; active: boolean }[] = [
    { label: "Home", href: "/", active: false },
  ];

  if (pathname.includes("/add-to-cart")) {
    currentStep = 1;
    breadcrumbs.push({ label: "Cart", active: true });
  } else if (pathname.includes("/checkout")) {
    if (step === "payment") {
      currentStep = 3;
      breadcrumbs.push(
        { label: "Cart", href: "/add-to-cart", active: false },
        { label: "Address", href: "/checkout?step=address", active: false },
        { label: "Payment", active: true }
      );
    } else {
      currentStep = 2;
      breadcrumbs.push(
        { label: "Cart", href: "/add-to-cart", active: false },
        { label: "Address", active: true }
      );
    }
  }

  return (
    <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between mb-9">
      {/* Breadcrumb */}
      <nav className="flex items-center gap-3">
        {breadcrumbs.map((crumb, index) => (
          <div key={crumb.label} className="flex items-center gap-3">
            {crumb.href ? (
              <span
                onClick={() => router.push(crumb.href!)}
                className="cursor-pointer font-oswald font-normal text-[18px] leading-[100%] tracking-[-0.02em] uppercase text-neutral-300 hover:text-neutral-500 transition-colors"
              >
                {crumb.label}
              </span>
            ) : (
              <span
                className={`font-oswald font-normal leading-[100%] tracking-[-0.02em] uppercase ${
                  crumb.active
                    ? "text-[20px] text-neutral-500"
                    : "text-[18px] text-neutral-300"
                }`}
              >
                {crumb.label}
              </span>
            )}
            {index < breadcrumbs.length - 1 && (
              <span className="font-normal text-[18px] leading-[100%] tracking-[-0.02em] text-neutral-300">
                /
              </span>
            )}
          </div>
        ))}
      </nav>

      {/* Stepper */}
      <div className="w-full sm:w-[350px] mt-6 sm:mt-0">
        <Stepper steps={CHECKOUT_STEPS} currentStep={currentStep} />
      </div>
    </div>
  );
}
